import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { POSTGRES_PATHS } from './paths';

/** Слон PostgreSQL — фирменный знак, контур из Simple Icons (CC0). */
export const PostgresIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {POSTGRES_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
